@if ((visualGuideManagerService.currentGuides$ | async)?.length) {
  @for (guide of visualGuideManagerService.currentGuides$ | async; track guide) {
<div (click)="visualGuideManagerService.startGuide(guide
.container);picked.emit()">{{guide.name}}</div>
  }
} @else {
  Brak przewodników dla tej strony
}
